import { API } from '@weave/schema-gen-ts/dist/apis/api/workspaces/v1/api.pb';
import { bindHTTP } from '@frontend/schema';

// Schema-bound HTTP client with fully typed request/response signatures.
// Transport options (such as baseUrl) are injected by hook wrappers/client helpers.
export const SchemaWorkspacesApiV1Service = bindHTTP(API);

// Stable service identifier used by shared query/mutation helpers for cache keys.
export const serviceName = 'workspaces-api-v1' as const;
